import { QueryStatus, useQuery } from '@tanstack/react-query';

import { GallerySceneLocationType } from '../CommonTypes';
import { fetchGallerySceneLocationSVG } from './fetchGallerySceneLocationSVG';

export const useGallerySceneLocationSVG = (svgUrl: string | undefined) => {
  const results = useQuery({
    queryKey: ['svgUrl', svgUrl],
    queryFn: () => fetchGallerySceneLocationSVG(svgUrl),
  });

  return [results?.data?.paths ?? [], results.status] as [GallerySceneLocationType[], QueryStatus];
};
